export default __webpack_public_path__ + "static/media/session-reload.fad329d1.svg";